import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import { useQuery } from '../hooks/useQuery';
import { useAuth } from '../hooks/useAuth';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTheme } from '@mui/material/styles';
import ItemContrato from '../components/ItemContrato';
import ItemPedido from '../components/ItemPedido';
import AlertaProtocoloVencido from '../components/AlertaProtocoloVencido';
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { isCnpj, serializeQueryString } from '../utils';
import XLSX from 'sheetjs-style';
import { Button } from '@mui/material';
import { useSnackbar } from '../hooks/useSnackbar';
import LaunchIcon from '@mui/icons-material/Launch';

import { async } from 'q';
import moment from 'moment';

let debounce = null;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const ExportarInformePage = () => {
  const { getExcelData, listarComboFornecedor, listarRelatorioInforme } =
    useQuery();
  const { user, isUsuarioSebrae, logout } = useAuth();
  const [loading, setLoading] = React.useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = React.useState({
    busca: '',
  });
  const [cnpjs, setCnpjs] = React.useState([]);
  const [relatorio, setRelatorio] = React.useState([]);
  const [ano, setAno] = React.useState(moment().format('YYYY'));
  const [fornecedores, setFornecedores] = React.useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const snackbar = useSnackbar();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCnpjs(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const listarRelatorio = async () => {
    let selCnpjs = [];
    if (cnpjs.length > 0) {
      cnpjs.map((res) => {
        selCnpjs.push(res.cnpj);
      });
    }

    let payload =
      selCnpjs.length > 0 ? { fornecedores: selCnpjs, ano: ano } : { ano: ano };

    const result = await listarRelatorioInforme(payload);

    setRelatorio(result.data.data);
  };

  const exportarExcel = async (filename) => {
    if (ano.length < 4) {
      snackbar.showSnackbar('Digite o ano corretamente.');
      return;
    }

    let selCnpjs = [];
    cnpjs.map((res) => {
      selCnpjs.push(res.cnpj);
    });
    let payload =
      selCnpjs.length > 0 ? { fornecedores: selCnpjs, ano: ano } : { ano: ano };
    const result = await listarRelatorioInforme(payload);

    setRelatorio(result.data.data);

    const worksheet = XLSX.utils.json_to_sheet(result.data.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Notas');
    XLSX.writeFile(workbook, 'Relatorio.xlsx');
  };

  const getFornecedores = async () => {
    setLoading(true);
    const result = await listarComboFornecedor();
    if (result && result.data && result.data.data) {
      const arr = result.data.data.map((item) => ({
        ...item,
      }));

      setFornecedores(arr);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getFornecedores();
  }, []);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item display="flex" alignItems="center">
            <ArticleIcon
              sx={{
                fontSize: 40,
              }}
            />
            <span style={{ color: 'white', fontSize: 20 }}>
              Relatório Informe Rendimentos
            </span>
          </Grid>
        </Grid>
      </AppBar>

      <AlertaProtocoloVencido />

      <Grid container spacing={2} paddingX={2}>
        <Grid item xs={12}>
          <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
            Pesquisar fornecedor
          </p>
          {/* <FormControl sx={{ m: 1, width: '100%' }}> */}

          <Autocomplete
            multiple
            id="tags-standard"
            style={{ height: 40 }}
            options={fornecedores}
            getOptionLabel={(option) => option.razao_social}
            onChange={(event, newValue) => {
              console.log(newValue);
              setCnpjs(newValue);
            }}
            // defaultValue={[top100Films[13]]}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                style={{ minHeight: '40px !important' }}
                placeholder="Listar fornecedores"
              />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            style={{ marginTop: 10 }}
            id="ano"
            label="Ano"
            variant="outlined"
            fullWidth
            type="number"
            onInput={(e) => {
              e.target.value = e.target.value
                .substring(0, 4)
                .replace(/[^0-9.]/g, '');
            }}
            inputProps={{
              min: 0,
              maxLength: 4,
            }}
            onChange={(event) => setAno(event.target.value)}
          />
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            onClick={() => listarRelatorio()}
            style={{ width: '100%', marginTop: 10 }}
          >
            Gerar
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            onClick={() => exportarExcel('relatorio')}
            style={{ width: '100%', marginTop: 10 }}
          >
            Exportar
          </Button>
        </Grid>
        <Grid item sm={12}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ marginTop: 60 }} />
            </Box>
          ) : (
            <div style={{ width: '100%', overflowY: 'scroll' }}>
              <table className="app_table">
                <thead
                  style={{
                    color: theme.palette.primary.main,
                    borderTop: `8px solid ${theme.palette.primary.light}`,
                  }}
                >
                  <tr>
                    <th>CPF/CNPJ</th>
                    <th>Nome</th>
                    <th>Data Envio</th>
                    <th>Versão</th>
                    <th>Arquivo</th>
                  </tr>
                </thead>

                <tbody>
                  {relatorio.map((res, index) => (
                    <tr
                      style={{ background: 'white' }}
                      key={`${index}-extrato-key`}
                    >
                      <td style={{ paddingLeft: '1.2rem' }}>{res.cpf_cnpj}</td>
                      <td style={{ paddingLeft: '1.2rem' }}>{res.nome}</td>
                      <td style={{ paddingLeft: '1.2rem' }}>
                        {res.data_envio}
                      </td>
                      <td style={{ paddingLeft: '1.2rem' }}>{res.versao}</td>
                      <td style={{ paddingLeft: '1.2rem' }}>
                        <IconButton target="_blank" href={res.arquivo}>
                          <LaunchIcon />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
